<div class="custom-background">
    <div class="row logo-margin">
        <div class="col-12 text-center">
            <img class="logo" src="./assets/images/logos/logo_bankei.png">
        </div>
    </div>

    <div class="row container-fluid m-0">
        <div class="col-lg-6 col-md-6 col-sm-12 text-center mx-auto">
            <div class="title">Autenticação de duplo fator</div>
            <div class="subtitle mt-3">Informe o PIN recebido por e-mail e/ou SMS</div>
            <form [formGroup]="loginPinFormGroup" #loginPinForm="ngForm" (ngSubmit)="onSubmit(loginPinFormGroup.value)">
                <div class="custom-input-container col-5 m-auto">
                    <input maxlength="6" formControlName="pin" type="text" class="custom-input text-center" />
                </div>
                <div *ngIf="form.pin.invalid && (form.pin.dirty || form.pin.touched)" class="custom-text-danger">
                    <div *ngIf="form.pin.errors.required">
                        O PIN é obrigatório.
                    </div>
                </div>
                <div class="row my-5">                   
                    <div class="col-12 d-flex justify-content-center">
                        <button [disabled]="!loginPinForm.valid" type="submit" class="custom-button">
                            <span>Próximo</span>
                        </button>
                    </div>
                </div>


            </form>
            <div class="row text-center login-option-container">
                <div class="col-6 vl-right login-option" (click)="sendPin()">Enviar PIN novamente</div>
                <div class="col-6 login-option" (click)="login()">Entrar com outra conta</div>
            </div>
        </div>
    </div>
</div>